// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"bb8f85ba","455":"f25eacb7"}[chunkId] + ".chunk.js";
};